import type { ApiRequestWith } from "@/api/types";
import type {
  Assessment,
  AssessmentSubmissionBody,
  AssessmentSubmissionResponse,
  Task,
} from "@/core/types";
import { httpAuth2 } from "@/api/auth";

type AssessmentRequestsTyped = {
  get_definition: ApiRequestWith<
    Assessment,
    { searchParams?: { version?: number }; urlParams: { assessmentId: string } }
  >;
  post_answer: ApiRequestWith<AssessmentSubmissionResponse, { body: AssessmentSubmissionBody }>;
  skip_task: ApiRequestWith<void, { urlParams: { taskId: Task["task_id"] } }>;
};

export const assessmentRequestsTyped: AssessmentRequestsTyped = {
  get_definition: function ({ context, searchParams, urlParams }) {
    return httpAuth2
      .get(`/v1/assessment/get_definition/${urlParams.assessmentId}`, {
        context,
        ...(searchParams?.version !== undefined && {
          searchParams: { version: searchParams.version },
        }),
      })
      .json<Assessment>();
  },

  post_answer: function ({ body, context }) {
    return httpAuth2
      .post("/v1/assessment/post_answer", { context, json: body })
      .json<AssessmentSubmissionResponse>();
  },

  skip_task: function ({ urlParams }) {
    return httpAuth2.post(`/v1/assessment/skip_task/${urlParams.taskId}`).json<void>();
  },
};
